module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"carrier-img ")
    ; __append(escapeFn( locals.type ))
    ; __append("\"></div> <div class=\"carrier-name\"><strong>")
    ; __append(escapeFn( locals.readable ))
    ; __append("</strong></div> <div class=\"row\"> <div class=\"col-sm-9\"> <dl class=\"inline-definition-list\"> <dt>Description</dt> <dd>")
    ; __append(escapeFn( locals.description ))
    ; __append("</dd> <br> <dt>Account ID</dt> <dd>")
    ; __append(escapeFn( locals.id ))
    ; __append("</dd> <br> <dt>Reference</dt> <dd>")
    ; __append(escapeFn( locals.reference ))
    ; __append("</dd> </dl> </div> <div class=\"col-sm-3 buttons\"> <a href=\"\" class=\"edit btn btn-xs btn-block btn-blue\">Edit</a> <a href=\"\" class=\"delete btn btn-xs btn-block btn-red\">Delete</a> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/carrier_account_list_item.ejs
// module id = 834
// module chunks = 1